import React, { useState } from "react";
import "./guidAccordionCell.scss";
import { Link } from "react-router-dom";
import { ChevronDown, Copy, Checkmark } from "@carbon/icons-react";

export default function GuidAccordionCell({ item, t, source = "relations" }) {
  const [open, setOpen] = useState(false);

  const [activeGuid, setActiveGuid] = useState(null);

  const handleCopy = async (guid) => {
    try {
      await navigator.clipboard.writeText(guid);

      setActiveGuid(guid);

      setTimeout(() => {
        setActiveGuid(null);
      }, 1000);
    } catch (e) {
      console.error("Copy failed", e);
    }
  };

  const renderRow = (guid, linkItem, isLink = true) => {
    const isCopied = activeGuid === guid;

    return (
      <div key={guid} className="cell-guid">
        {isLink ? (
          <Link
            to={`/${guid}`}
            state={{ item: linkItem }}
            className="guid-link"
          >
            {guid}
          </Link>
        ) : (
          <div className="guid-link">{guid}</div>
        )}

        <div
          className={`icon-wrapper ${isCopied ? "copied" : ""}`}
          onClick={() => handleCopy(guid)}
        >
          <Copy className="icon copy-icon" size={16} />
          <Checkmark className="icon check-icon" size={16} />
        </div>
      </div>
    );
  };

  if (source === "balance") {
    return renderRow(item.uuid, item, false);
  }

  if (item.kind !== "Farmer" || !Array.isArray(item.farms)) {
    return renderRow(item.guid, item, true);
  }

  return (
    <div className="guid-collapsible">
      <div className="guid-collapsible-header" onClick={() => setOpen(!open)}>
        <span>
          {t("main.chat.chatClientsTable.accounts", {
            count: item.farms.length,
          })}
        </span>

        <ChevronDown
          size={16}
          className={`guid-chevron ${open ? "guid-chevron--open" : ""}`}
        />
      </div>

      <div className={`guid-collapsible-content ${open ? "open" : ""}`}>
        {item.farms.map((farm) => renderRow(farm.guid, item, true))}
      </div>
    </div>
  );
}
